import MainWraper from './MainWraper';
import { styled } from '@stitches/configed';
import Button from '../Common/Button';
import { Result } from '../Common/Result';
import { useNavigate } from 'react-router-dom';

const Container = styled('div', {
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 16,
});

const Page404 = () => {
  const navigate = useNavigate();
  return (
    <MainWraper>
      <Container>
        <Result
          type="404"
          title="Đường dẫn hoặc trang không tìm thấy"
          message="Mình tìm muốn ốm luôn mà không thấy. Bạn kiểm tra lại địa chỉ hoặc đường dẫn nhé."
        >
          <Button
            btnType="primary"
            style={{ width: 254 }}
            onClick={() => navigate('/')}
          >
            Quay lại Trang chủ
          </Button>
        </Result>
      </Container>
    </MainWraper>
  );
};

export default Page404;
